module.exports = __webpack_public_path__ + "img/appscrn_3_coins.2fd1641c.png";